// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "create-invoice";

export const createInvoiceParamsSchema = z.object({
  loadIds: z
    .array(z.string().uuid())
    .min(1, "At least one load ID is required"),
  orgId: z.string().uuid().optional(),
});

export const createInvoiceResponseSchema = z.object({
  invoiceId: z.string().uuid(),
});




export type CreateInvoiceParams = z.infer<typeof createInvoiceParamsSchema>;

export type CreateInvoiceResponse = z.infer<typeof createInvoiceResponseSchema>;




// broker/create-invoice endpoint
export function createInvoice(
  params: z.input<typeof createInvoiceParamsSchema>
): Promise<CreateInvoiceResponse> {
  return requestHandler(
    "broker/create-invoice",
    params,
    createInvoiceResponseSchema,
  );
}

